const iconAssets = {
  checkStandard: '/images/icon-check-2019.png',
  checkPink: '/images/icon-check-pink.png',
  checkChristmas: '/images/icon-check-red.png',
  checkCF2019: '/images/icon-check-2019.png'
};

export default iconAssets;
